<template>
  <router-view />
</template>

<script>
export default {
  name: 'ReportingContainer',
};
</script>
